import type { GeoLocation } from '../../types/core';
import type { SubscriptionType } from '../../types/subscription';

/** Must stay aligned with `DialogStage` in `order-process.component.ts`. */
export type FachkraftUpgradeDialogView =
  | 'roleSelect'
  | 'offers'
  | 'ordering'
  | 'upgradeSchoolUnit'
  | 'upgradeSchoolAuthority'
  | 'upgradeSummary'
  | 'upgradeOffers'
  | 'upgradeOrderingAuthority'
  | 'upgradeOrderingUnit'
  | 'upgradeOrderSuccess';

export interface FachkraftUpgradeStep4Snapshot {
  form: Record<string, unknown>;
  schoolLocation?: GeoLocation;
}

/**
 * Persists the «Upgrade auf Schul-Account» dialog (Fachkraft) across close/back and page reloads
 * until logout or a successful upgrade.
 */
export interface FachkraftUpgradeOrderProcessDraft {
  firebaseUid: string;
  view: FachkraftUpgradeDialogView;
  upgradeRole: 'schuleinheit' | 'schulgemeinde' | null;
  upgradeSummaryData: unknown;
  createdId: string | null;
  selectedOffer: SubscriptionType | null;
  page: number;
  startedAtOrdering: boolean;
  schuleinheitStep4?: FachkraftUpgradeStep4Snapshot;
  schulgemeindeStep4?: FachkraftUpgradeStep4Snapshot;
  savedAt: string;
}

export const FACHKRAFT_UPGRADE_ORDER_PROCESS_DRAFT_KEY =
  'bn_fachkraft_upgrade_order_process_v1';

export function saveFachkraftUpgradeOrderProcessDraft(
  draft: Omit<FachkraftUpgradeOrderProcessDraft, 'savedAt'> & {
    savedAt?: string;
  }
): void {
  const payload: FachkraftUpgradeOrderProcessDraft = {
    ...draft,
    savedAt: draft.savedAt ?? new Date().toISOString(),
  };
  sessionStorage.setItem(
    FACHKRAFT_UPGRADE_ORDER_PROCESS_DRAFT_KEY,
    JSON.stringify(payload)
  );
}

export function loadFachkraftUpgradeOrderProcessDraft(): FachkraftUpgradeOrderProcessDraft | null {
  try {
    const raw = sessionStorage.getItem(
      FACHKRAFT_UPGRADE_ORDER_PROCESS_DRAFT_KEY
    );
    if (!raw) return null;
    return JSON.parse(raw) as FachkraftUpgradeOrderProcessDraft;
  } catch {
    return null;
  }
}

export function clearFachkraftUpgradeOrderProcessDraft(): void {
  sessionStorage.removeItem(FACHKRAFT_UPGRADE_ORDER_PROCESS_DRAFT_KEY);
}
